import React from "react";

import Footer from "../Footer";
import Header from "../Header";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { useEffect } from "react";
import OuterCalculator from "components/OuterCalculator";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const CompareDiffForms = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("frilans-konsult-lon-fakturera-utan-foretag");
  const { t } = useTranslation();

  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const selfEmployee = `${blobURL}/self_employee.jpg`;
  let language = localStorage.getItem("i18nextLng");
  const businessGIF = `${blobURL}/business.gif`;
  const freelancerGIF = `${blobURL}/freelancer.gif`;
  const invoiceGIF = `${blobURL}/invoice.gif`;
  const invoiceCalculatorGIF = `${blobURL}/invoice-calculator.gif`;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="network-page">
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>{t("Own company or invoice without a company | Invozio")}</title>
        <meta
          name="description"
          content={t(
            "Invoice without a company easily as a freelancer or consultant. Avoid having your own company, get paid directly, and focus on your assignment. A convenient solution for self-employment!"
          )}
        />
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/freelance-consultant-salary-invoice-without-a-company"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/frilans-konsult-lon-fakturera-utan-foretag"
          />
        )}
      </Helmet>
      <Header />
      <Container className="p-0 self_new responsive_self">
        <div className="home-page self_employeees new_desgn_insurance new_margin_header mb-0 p-0">
          <section className="insurns_wrap self-empoyee">
            <div className="container">
              <div className="row align-items-center p-2">
                <div className="col-md-6">
                  <div className="slf_text">
                    <h1 className="security_about text-uppercase mb-0 p-0">
                      {" "}
                      {t("Own business or invoicing without a company?")}
                    </h1>
                    {!user && (
                      <Button
                        variant=""
                        className="mt-3 new_theme_btn "
                        onClick={() =>
                          navigate(
                            language === LOCALES.EN_US
                              ? `/emailregister?lang=${LOCALES.EN_US}`
                              : `/e-postregister?lang=${LOCALES.SV_SE}`
                          )
                        }
                      >
                        {t("Create Free Account")}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="text-right self_imgs">
                    <img
                      src={selfEmployee}
                      alt="self-employment"
                      className="img-fluid"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="newdesign">
            <div className="container p-0">
              <div className="without_background">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={businessGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <div>
                      <h2 className="heading_edit">
                        {t("Compare different forms of business")}
                      </h2>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t(
                            "Compare forms of business: Self-employed or Invozio?"
                          )}
                        </h3>
                        <p className="text-align: left">
                          {t(
                            "Choosing your own path as a self-employed person can be a challenge, with different options for managing your business and income. Sole proprietorship, limited company, or invoicing as a private person, all have their pros and cons."
                          )}{" "}
                        </p>
                        <p className="text-align: left">
                          {t("As a")}
                          <Link
                            to={
                              language === LOCALES.EN_US
                                ? `/business?lang=${LOCALES.EN_US}`
                                : `/foretag?lang=${LOCALES.SV_SE}`
                            }
                            style={{
                              fontWeight: "600",
                              textDecoration: "underline",
                            }}
                          >
                            {" "}
                            <u>{t("business owner")}</u>
                          </Link>{" "}
                          {t(
                            "You gain the freedom to build and run your own business, but it also comes with responsibilities for accounting, taxes, and administration. Starting a limited company can offer benefits such as limited personal liability and the potential for growth, but it also entails higher demands for administration and reporting"
                          )}{" "}
                        </p>
                        <p className="text-align: left">
                          {t(
                            "On the other hand, platforms like Invozio offer an alternative that allows you to invoice without having to start your own business, known as"
                          )}{" "}
                          <Link
                            style={{
                              fontWeight: "600",
                              textDecoration: "underline",
                            }}
                            to={
                              language === LOCALES.EN_US
                                ? `/self-employment?lang=${LOCALES.EN_US}`
                                : `/egenanstallning?lang=${LOCALES.SV_SE}`
                            }
                          >
                            {" "}
                            <u>{t("self-employment")}</u>
                          </Link>
                          {"."}{" "}
                          {t(
                            "This can be an attractive choice for freelancers or consultants who want to focus on their core activities without worrying about bureaucracy. By using Invozio, you avoid complicated registration processes and can start invoicing immediately, saving time and energy. Additionally, Invozio handles taxes and fees for you, reducing the risk of financial mistakes."
                          )}
                        </p>
                        <p className="text-align: left">
                          {t(
                            "The choice between starting your own business or using a service like Invozio depends on your long-term goals, how much time and energy you want to invest in administration, and how much control you want over your operations. For some, the freedom and opportunities of running a business might be more appealing, while others might appreciate the simplicity and flexibility of"
                          )}{" "}
                          <Link
                            to={language === LOCALES.EN_US ? `/?lang=${LOCALES.EN_US}` : `/?lang=${LOCALES.SV_SE}`}
                            style={{
                              fontWeight: "600",
                              textDecoration: "underline",
                            }}
                          >
                            {" "}
                            <u> {t("invoicing without a company")}</u>
                          </Link>
                          {"."}{" "}
                          {t(
                            "Regardless of your choice, it's important to carefully consider which options best suit your lifestyle and business strategy."
                          )}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("Start your own business or Invozio?")}
                        </h3>
                        <p className="text-align: left">
                          {t(
                            "Starting your own business in the form of a sole proprietorship or limited liability company can feel like a natural starting point for many."
                          )}
                        </p>
                        <p className="mt-1">
                          {t(
                            "This offers complete control and ownership of your business, but also comes with a host of requirements and responsibilities. Accounting, administration, tax and other legal requirements can take a lot of time and energy, which can divert from what you love most - your work."
                          )}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("Avoid all administration and invoicing")}
                        </h3>
                        <p className="text-align: left">
                          <Link
                            style={{
                              fontWeight: "600",
                              textDecoration: "underline",
                            }}
                            to={
                              language === LOCALES.EN_US
                                ? `/invoicing-as-an-individual_self-employed?lang=${LOCALES.EN_US}`
                                : `/fakturera-som-privatperson_egenanstalld?lang=${LOCALES.SV_SE}`
                            }
                          >
                            {" "}
                            <u>
                              {t("Invoicing as a private individual ")}
                            </u>{" "}
                          </Link>

                          {t(
                            "may seem like an easier option, but it also has its own challenges. Here, too, you need to keep track of your income, taxes and invoicing, and you may lack the protection and support that comes with running a formal business. This is where Invozio comes into the picture. As a third way for self-employed people, we offer a solution that simplifies the process and allows you to focus on your work. We minimize accounting and administration requirements, so you can spend more time doing what you do best."
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="with_background">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={invoiceGIF}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("With Invozio you can:")}
                        </h3>
                        <p className="insurance_para">
                          {t("Invoicing without your own company")}
                        </p>
                        <p>
                          {t(
                            "This means you can start making money straight away without having to worry about business registration or administration."
                          )}{" "}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("Get access to our expertise")}
                        </h3>
                        <p className="insurance_para">
                          {t(
                            "We offer advice and support to help you navigate the business world."
                          )}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("Get help with negotiations")}
                        </h3>
                        <p className="insurance_para">
                          {t(
                            "We can negotiate with clients on your behalf to ensure that you receive the compensation you deserve."
                          )}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t("Enjoy more flexibility")}
                        </h3>
                        <p className="insurance_para">
                          {t(
                            "As a self-employed person with Invozio, you have the flexibility to work when you want, where you want, without having to deal with the administrative burden of running your own business."
                          )}
                        </p>
                      </div>
                      <div className="new_text">
                        <h3 className="mb-2 accident_ins">
                          {t(
                            "Invozio - for your business, invoicing and administration"
                          )}
                        </h3>
                        <p className="insurance_para">
                          {t(
                            "So, if you are about to become self-employed, consider Invozio as your choice. We offer the flexibility and freedom to run your business on your terms, with support and advice every step of the way. Welcome to Invozio - where we take care of the details so you can focus on your work"
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="without_background">
                <h2 className="heading_edit p-0">
                  {t(
                    "Invoicing without a company for freelancers, consultants, and self-employed individuals"
                  )}
                </h2>
                <p>
                  {t(
                    "Are you a freelancer or consultant looking for a convenient way to manage your income without having to start your own company? Discover how you can maximize your earnings and minimize administrative burdens with our solution for invoicing without a company. In today's global job market, the flexibility and freedom for freelancers and consultants are greater than ever, especially during and after the pandemic when people got accustomed to working from anywhere. However, with freedom comes the challenge of efficiently handling invoicing and income. Our service offers a simple solution to manage your freelancer or consultant income without the hassle and time commitment of running your own business. With Invozio, everything is taken care of for you at a low fee of only 1.9 percent"
                  )}
                </p>
                <div className="row align-items-center mt-4">
                  <div className="col-md-12">
                    <img
                      src={freelancerGIF}
                      alt="logo"
                      className="imganimate"
                      loading="lazy"
                    />
                    <h2 className="heading_edit">
                      {t("Can I as an Individual Invoice without a company?")}
                    </h2>
                    <p>
                      {t("Yes, it is possible to invoice without a company")}
                      <Link
                        style={{
                          textDecoration: "underline",
                        }}
                        to="/"
                        className="heading_edit"
                      >
                        {" "}
                        <u>invozio.com</u>.{" "}
                      </Link>
                      {t(
                        "This is known as self-employment. Self-employment means that as an individual, you work as a freelancer or consultant and invoice for your services through platforms like Invozio for a low fee of only 1.9 percent. This means that you can invoice as an individual without a company and receive payment based on what you have invoiced to your clients"
                      )}
                    </p>

                    <h3 className="heading_edit">
                      {t(
                        "How does an invoice without a company work in practice?"
                      )}
                    </h3>
                    <p>
                      {t(
                        "When you invoice without a company, you do it through another company. A self-employment company like Invozio takes care of all administration related to your invoicing, including invoicing, payments, and taxes. As a self-employed individual, you pay a low fee of 1.9 percent of the invoiced amount. In this case, you pay this fee to Invozio to cover its expenses. Self-employment can be a good option for those who want to start working as a freelancer or consultant. It is a simple and convenient way to invoice without the need to start your own company"
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="with_background">
                <div className="row align-items-center">
                  <div className="col-md-12">
                    <img
                      src={invoiceCalculatorGIF}
                      alt="logo"
                      className="imganimateright"
                      loading="lazy"
                    />
                    <h3 className="heading_edit">
                      {t("How much salary do I receive for my invoice?")}
                    </h3>
                    <p>
                      {t(
                        "It depends on the company you choose. Some companies charge exorbitant amounts and percentages. You can see the comparison between the leading invoicing companies here"
                      )}{" "}
                      <Link
                        style={{
                          fontWeight: "600",
                          textDecoration: "underline",
                        }}
                        to={
                          language === LOCALES.EN_US
                            ? `/emailregister?lang=${LOCALES.EN_US}`
                            : `/e-postregister?lang=${LOCALES.SV_SE}`
                        }
                      >
                        <u>{t("Start Invoicing Today")}</u>
                      </Link>{" "}
                      {t(
                        ". We take pride in offering our customers the lowest fee of 1.9 percent along with all the functionality you need for invoicing. For example, if you send an invoice without a company for 100,000 SEK, the cost will be a low fee of 1.9 percent. This means that Invozio bases your salary on 98,000 SEK."
                      )}
                    </p>

                    <h2 className="heading_edit">
                      {t(
                        "Calculator on how your salary is calculated when invoicing without a company"
                      )}
                    </h2>
                    <p className="m-0">
                      {t(
                        "Invozio is a platform that makes it easy for you to start and run your own business without worrying about administration, invoicing, or negotiations. Feel free to try our calculator to see the salary you would receive for the sum of your invoices"
                      )}
                    </p>

                    <OuterCalculator />

                    <h3 className="heading_edit">
                      {t(
                        "Can't I just invoice as an individual without a company?"
                      )}
                    </h3>
                    <p>
                      {t(
                        "In Sweden, there are opportunities for individuals to invoice services or goods tax-free up to a certain amount. If your total business activities in a year generate income that is below 22,208 SEK, these incomes are considered tax-free. This can be particularly relevant for those running a small side business"
                      )}
                    </p>

                    <h4 className="heading_edit">
                      {t("What applies when invoicing with hobby business?")}
                    </h4>
                    <p>
                      {t(
                        "Hobby activities, often of smaller scale and not primarily aimed at financial gain, can also generate income that can be invoiced without having to pay income tax on it. However, it is important to note that whether you invoice as an individual or within the framework of a hobby business, there are rules regarding VAT registration that must be considered. If your total sales exceed 80,000 SEK excluding VAT during an accounting year, you are obligated to register for VAT and report this to the Swedish Tax Agency (Skatteverket). This applies regardless of whether your business is classified as a hobby activity or not. VAT registration means that you must add VAT to your invoices and then report and remit this VAT to the government."
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="without_background">
                <h2 className="heading_edit">
                  {t(
                    "Skip Invoicing, Finance, Administration, and Bookkeeping with Invozio"
                  )}
                </h2>
                <p>
                  {t(
                    "Not only does Invozio simplify your invoices, payroll management, and administration, but we also provide expertise and support in the form of advice and guidance to help you get started and navigate the business world. Additionally, we assist in negotiations successfully. We can negotiate with clients on your behalf to ensure you receive the compensation you deserve. Finally, we offer you great flexibility; you can work when and where you want without being tied to a fixed schedule. With expertise in all areas, we aim to make you feel as secure as possible in invoicing and receiving your salary. To further complement our offering, we provide advice and support for tax and legal matters"
                  )}
                </p>
                <h2 className="heading_edit">
                  {t(
                    "Sending an invoice as a private individual without business tax (F-tax)"
                  )}
                </h2>
                <p>
                  {t(
                    "Sending an invoice as a private individual without F-tax can be a practical solution for occasional or one-time services. It's important to understand that without an F-tax certificate, you are not considered a business entity. This means you cannot claim VAT deductions or deduct expenses related to the service. When invoicing as a private individual, you must include your personal identification number instead of an organization number and clearly specify that there is no VAT on the invoice. It's also crucial to report the income on your personal tax return. This can be a good option for smaller services or hobby activities, but it's important to be aware of the tax implications and know that there is a limit to how much you can earn before you need to register as a sole proprietor and apply for F-tax."
                  )}
                </p>

                <h2 className="heading_edit tailored">
                  {t(
                    "A designed service for invoicing without a company for freelancers, consultants, and self-employed individuals"
                  )}
                </h2>
                <p>
                  {t(
                    "Our service is designed to make your life as a freelancer or consultant easier. You can focus on what you do best while we take care of the rest. Whether you're an experienced freelancer or new to the consulting world, our solution for invoicing without a company is the perfect choice for managing your finances efficiently and stress-free. Start maximizing your freelance or consultant income today. Discover how easy it can be to handle your invoicing and salary with our user-friendly service, which is also the most affordable on the market"
                  )}
                </p>
                <p>
                  {t(
                    "Our system offers detailed reports and analyses to help you better understand your financial success. With real-time tracking of income and expenses, you can easily see the value of your work. This transparency in financial management keeps you constantly updated. Let us help you elevate your freelance or consulting business to new heights."
                  )}
                </p>

                <Button
                  className="mt-4 create-account filled home_create_account"
                  onClick={() => {
                    navigate(
                      language === LOCALES.EN_US
                        ? `/emailregister?lang=${LOCALES.EN_US}`
                        : `/e-postregister?lang=${LOCALES.SV_SE}`
                    );
                    sessionStorage.setItem("accountType", 1);
                  }}
                >
                  {t("Start invoicing without a company today")}
                </Button>
              </div>
            </div>
          </section>
        </div>
      </Container>
      <Footer dashboardFooter={dashboardFooter} />
    </div>
  );
};

export default CompareDiffForms;
